import { useEffect } from "react";

import { usePortalPage } from "@layouts/PortalPage/PortalPageContext";

type Props = {
  children: React.ReactNode;
};

export const PortalSubNavigation = ({ children }: Props) => {
  const { setSubNavigation } = usePortalPage();

  useEffect(() => {
    setSubNavigation(children);

    return () => {
      setSubNavigation(null);
    };
  }, [children, setSubNavigation]);

  return null;
};
